"use client";

import SharedBriefingApp from "../../_shared/components/BriefingApp";
import BriefingForm from "./BriefingForm";
import { DASHBOARD_BRIEFING_CONFIG } from "../config";
import type { BriefingData } from "../types";

/**
 * Client boundary for this briefing: binds the shared app to this tool's
 * config and form (the form reference is not serializable, so the binding
 * has to happen on the client side of the server/client seam).
 */
export default function BriefingApp({ data }: { data: BriefingData }) {
  return (
    <SharedBriefingApp
      data={data}
      config={DASHBOARD_BRIEFING_CONFIG}
      FormComponent={BriefingForm}
    />
  );
}
